import type { ReactElement } from "react";
import { Fragment } from "react";

import { Settings } from "lucide-react";

import { Box, HStack, Icon, IconButton } from "@chakra-ui/react";

import { MenuContent, MenuItem, MenuRoot, MenuSeparator, MenuTrigger } from "@components/ui/menu";

type SettingsMenuItem = {
  label: string;
  value: string;
  icon: ReactElement;
  onClick?: () => void;
  disabled?: boolean;
  hover?: {
    bg: string;
    color: string;
  };
  color?: string;
  seperator?: "above" | "below";
};

type Props = {
  menuItems: SettingsMenuItem[];
  disabled: boolean;
};

export default function SettingsButton({ menuItems, disabled }: Props) {
  return (
    <MenuRoot
      size="sm"
      onSelect={(selectedItem) => {
        const menuItem = menuItems.find((item) => item.value === selectedItem.value);
        if (menuItem && !menuItem.disabled && menuItem.onClick) {
          menuItem.onClick();
        }
      }}
    >
      <MenuTrigger
        asChild
        disabled={disabled}
      >
        <IconButton
          size="xs"
          variant="subtle"
        >
          <Settings />
        </IconButton>
      </MenuTrigger>
      <MenuContent>
        {menuItems.map((item) => (
          <Fragment key={item.value}>
            {item.seperator === "above" && <MenuSeparator />}
            <MenuItem
              value={item.value}
              color={item.color || ""}
              _hover={item.hover ? item.hover : { bg: "gray.100" }}
              cursor="pointer"
              pr="2rem"
              py="8px"
              disabled={item.disabled}
            >
              <HStack
                flex="1"
                gap="6px"
                alignItems="center"
              >
                <Box
                  w="4"
                  display="flex"
                  alignItems="center"
                >
                  <Icon size="sm">{item.icon}</Icon>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                >
                  {item.label}
                </Box>
              </HStack>
            </MenuItem>
            {item.seperator === "below" && <MenuSeparator />}
          </Fragment>
        ))}
      </MenuContent>
    </MenuRoot>
  );
}
